export const stringPosition = (text: string) => {
  return {
    x: text.split(",")[0]?.replace('"', ""),
    y: text.split(",")[1]?.replace('"', ""),
  };
};
